import { DefaultFetchService } from "app/services/fetchService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { createKeyword } from "../createKeyword";
import type { Keyword } from "../types";

interface RawData {
    SeedKeyword: Array<SeedKeyword>;
    SuggestedRecords: Array<SeedKeyword>;
}

interface SeedKeyword {
    Keyword: string;
    AverageVolume: number;
}

export const KEYWORD_LIST_SUGGESTION_PATHNAME = "api/MarketResearch/DemandSearchTrends/KeywordListSuggestion";

export const fetchKeywords = async (countryId: number, seedKeyword: string): Promise<{ keywords: Keyword[] }> => {
    const fetchService = DefaultFetchService.getInstance();
    const params = {
        websource: devicesTypes.TOTAL,
        keyword: seedKeyword,
        country: countryId,
    };

    return fetchService.get<RawData>(KEYWORD_LIST_SUGGESTION_PATHNAME, params).then((response) => {
        const keywordsWithoutSeedKeyword: Keyword[] = response.SuggestedRecords.map(({ Keyword, AverageVolume }) =>
            createKeyword({
                term: Keyword,
                volume: AverageVolume,
            }),
        );
        const seedKeywordResult = createKeyword({
            term: response.SeedKeyword[0].Keyword,
            volume: response.SeedKeyword[0].AverageVolume,
        });
        const result = {
            keywords: [...keywordsWithoutSeedKeyword, seedKeywordResult],
        };
        return result;
    });
};
